export const RESTAURANT_NAME = 'Vatti Taverna';
export const RESTAURANT_PHONE = '+34931764178';
export const RESTAURANT_PHONE_DISPLAY = '+34 931 76 41 78';
export const RESTAURANT_WHATSAPP = '+34668568117';
export const RESTAURANT_WHATSAPP_DISPLAY = '+34 668 568 117';
export const RESTAURANT_WHATSAPP_URL = 'https://wa.me/34668568117';
export const RESTAURANT_EMAIL = 'barssgroup5@gmail.com';
export const RESTAURANT_ADDRESS = 'Passeig de Sant Antoni, 19';
export const RESTAURANT_CITY = 'Sants-Montjuic, 08014 Barcelona';
export const RESTAURANT_MAPS_URL =
  'https://www.google.com/maps/search/?api=1&query=Passeig%20de%20Sant%20Antoni,%2019,%20Sants-Montjuic,%2008014%20Barcelona';
